import React from 'react';
import { Redirect } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import "bootstrap/dist/css/bootstrap.css";
import '../../assets/css/style.css';

import * as api from '../../api/api';

class UserLoginPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loginData: {
                login: '',
                password: ''
            }
        }

        this.props.updateLoader({
            loaded: true,
            message: ""
        });
    }

    render() {
        if (this.state.needRedirect) {
            // return <Redirect to="/"/>
            // window.location.href = "http://openiot.tyuiu.ru/imms/monitor";
            window.location.href = "/monitor";
        }
        
        return (
            <div>
                <h4 className="mb-4">Вход в систему</h4>

                <Formik
                    initialValues={this.state.loginData}
                    validate={values => {
                        let errors = {};
                        if (!values.login) {
                            errors.name = 'Пожалуйста, заполните это поле';
                        };

                        if (!values.password) {
                            errors.description = 'Пожалуйста, заполните это поле';
                        };

                        return errors;
                    }}
                    onSubmit={(values, { setSubmitting }) => {
                        
                        this.props.updateLoader({
                            loaded: false,
                            message: ""
                        });
                        
                        api.login(values).then(
                            (r) => {
                                this.setState({ needRedirect: true });

                                this.props.updateLoader({
                                    loaded: true
                                });
                            },
                            (error) => {
                                this.props.updateLoader({
                                    loaded: true,
                                    message: "Ошибка при выполнении входа в систему: " + error.message
                                });
                            }
                        );
                    }}
                >
                    {({ isSubmitting }) => (
                        <Form className="">
                            <div className="form-group">
                                <label>Имя пользователя</label>
                                <Field className="form-control" type="text" name="login" />
                                <ErrorMessage className="form-error-message" name="login" component="div" />
                            </div>
                            <div className="form-group">
                                <label>Пароль</label>
                                <Field className="form-control" type="password" name="password" />
                                <ErrorMessage className="form-error-message" name="password" component="div" />
                            </div>
                            <button className="btn btn-primary-custom" type="submit">
                                Войти
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        );
    }
}

export default UserLoginPage;